// extracted by mini-css-extract-plugin
export var aircallIframe = "_lk-3";
export var fabContainer = "_lk-5";
export var fabRinging = "_lk-6";
export var loadingOverlay = "_lk-4";
export var pulse = "_lk-7";
export var widgetContent = "_lk-2";
export var widgetPanel = "_lk-0";
export var widgetPanelExpanded = "_lk-1";